<template>
  <div class="pdf-document" id="pdf-content" :class="{'cursor-pointer': !isMaximized}" @click.stop="$emit('maximize')">
    <PDFPage
      v-for="page in pages"
      :scale="scale"
      :key="page.pageNumber"
      :page="page"
    />
  </div>
</template>

<script>
  // PDFDocument renders an entire PDF inline using
  // PDF.js and <canvas>. Currently does not support,
  // rendering of selected pages (but could be easily
  // updated to do so).
  // import debug from 'debug';

  // const log = debug('app:components/PDFDocument');

  import PDFPage from './PDFPage';

  import range from 'lodash/range';
  import reportService from "../../../../providers/reportService";

  import AppConstants from "../../../../appConstants";
  import floor from "../../../../helpers/floor";
  // import {getDocument} from "pdfjs-dist/webpack";
  // import "pdfjs-dist/web/pdf_viewer.css";
  // import pdfjsLib from "pdfjs-dist";
  // import pdfjsLib from "pdfjs-dist";
  // const pdfjsLib = require('pdfjs-dist');
  // pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry');
  // const pdfjsLib = require("pdfjs-dist");
  // console.log('-> ', pdfjsLib);
  // import * as pdfjsLib from 'pdfjs-dist/webpack';
  // import * as pdfjs from 'pdfjs-dist/webpack';

  export default {
    components: {
      PDFPage,
    },
    props: {
      url: {
        type: String,
      },
      dataId: String,
      scale: {
        type: Number,
        default: 1.0,
      },
      isConsulting: Boolean,
      isNews: Boolean,
      isMaximized: Boolean,
    },

    data() {
      return {
        pdf: undefined,
        pages: [],
      };
    },

    computed: {
      firstPage() {
        if (!this.pages.length) return undefined;
        const [page] = this.pages;
        return page;
      },
      defaultViewportWidth() {
        return this.firstPage ? this.firstPage.getViewport(1.0).width : 0;
      },
    },

    watch: {
      scale(val) {
        // console.log('[PDFDocument][change scale] ', val)
      },
      pdf: {
        handler(pdf) {
          this.pages = [];
          const promises = range(1, pdf.numPages + 1).map(number => pdf.getPage(number));
          return Promise.all(promises).then(pages => (this.pages = pages)).then(() => {
            this.updateScale();
          })
        }
      },
    },

    methods: {
      updateScale() {
        const PIXEL_RATIO = window.devicePixelRatio || 1;
        const VIEWPORT_RATIO = 0.95;

        const pixelWidth = this.$el.clientWidth * PIXEL_RATIO;

        const scaleFactor = floor(pixelWidth / this.defaultViewportWidth, 2);
        const pageWidthScale = scaleFactor * VIEWPORT_RATIO;

        this.$emit("updateScaleDocumentEvent", pageWidthScale);
      },
      toggleLoading(show) {
        if (show) {
          this.$vs.loading({
            container: "#pdf-content",
            scale: 0.6
          });
        } else {
          this.$vs.loading.close("#pdf-content > .con-vs-loading");
        }
      },
      async fetchPDF() {
        const pdfjsLib = await import('pdfjs-dist/build/pdf');
        const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

        // console.log(pdfjs)
        // const pdfjsLib = await import("pdfjs-dist/webpack");
        // const pdfjsLib = await import('pdfjs-dist/webpack');
        // pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.js";

        // const pdfjsLib = await import('pdfjs-dist/build/pdf');
        // const pdfjsLib = require('pdfjs-dist/webpack');
        // const pdfjsLib = await import('pdfjs-dist/build/pdf');
        // const pdfjsLib = require('pdfjs-dist/build/pdf');
        // pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry');
        // const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker');
        // pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

        // const pdfjsLib = await import('pdfjs-dist/build/pdf');
        // console.log('[pdfjsLib]', pdfjsLib);
        // const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
        // pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

        this.toggleLoading(true);

        const params = new URLSearchParams();
        // params.append('download', false);
        // params.append('isConsulting', this.isConsulting);
        // params.append('isNews', this.isNews);

        if (this.url) {
          pdfjsLib.getDocument(this.url).promise.then(pdf => {
            this.pdf = pdf;
            this.toggleLoading(false);
          })
          // reportService
          //   .readDocumentFileWithUrl(this.url, params)
          //   .then(response => {
          //     const bytes = this.CryptoJS.AES.decrypt(response.data, AppConstants.PDF_PWD);
          //     const pdfPlain = bytes.toString(this.CryptoJS.enc.Utf8);
          //     const pdfData = Buffer.from(pdfPlain, 'base64');
          //     console.log(pdfData);

          //     pdfjsLib.getDocument({data: pdfData}).promise.then(pdf => {
          //       this.pdf = pdf;
          //       this.toggleLoading(false);
          //     })
          //   })
          //   .catch(error => {
          //     this.toggleLoading(false);
          //     console.log(error);
          //   });
        } else {
          reportService
            .readDocumentFile(this.dataId, params)
            .then(response => {
              const bytes = this.CryptoJS.AES.decrypt(response.data, AppConstants.PDF_PWD);
              const pdfPlain = bytes.toString(this.CryptoJS.enc.Utf8);

              // const pdfData = atob(pdfPlain);
              const pdfData = Buffer.from(pdfPlain, 'base64');
              // console.log(pdfData);

              // import("pdfjs-dist").then((pdfjsLib) => {
              //   pdfjsLib.getDocument({data: pdfData}).promise.then(pdf => {
              //     this.pdf = pdf;
              //     this.toggleLoading(false);
              //   })
              // });

              pdfjsLib.getDocument({data: pdfData}).promise.then(pdf => {
                this.pdf = pdf;
                this.toggleLoading(false);
              })

              //  import(
              //   'pdfjs-dist/webpack'
              //   ).then(pdfjs => pdfjs.getDocument({data: pdfData}))
              //   .then(pdf => {
              //     this.pdf = pdf;
              //     this.toggleLoading(false);
              //   });


            })
            .catch(error => {
              this.toggleLoading(false);
              console.log(error);
            });
        }

      },
    },

    mounted() {
      this.fetchPDF();
    },
  };
</script>
<style>
  /*.pdf-document {*/
  /*  !*position: fixed;*!*/
  /*  !*overflow: scroll;*!*/
  /*  width: 100%;*/
  /*  height: 90%;*/
  /*}*/

  .pdf-document {
    /* position: absolute; */
    overflow: auto;
    width: 100%;
    top: 150px;
    bottom: 0;
    left: 0;
    right: 0;
    background: #efefef;
    padding-top: 10px;
  }
  .theme-dark .pdf-document {
    background-color:#353e45 !important

  }

  .scrolling-page {
    margin-bottom: 1em;
  }

  @media print {
    .pdf-document {
      position: static;
    }
  }
</style>
